function getProducts (container) {
  const productContainers = container.querySelectorAll('[data-rb-item-id]');
  return Array.from(productContainers).map(productContainer => {
    return {
      id: productContainer.dataset.rbItemId,
      price: productContainer.querySelector('.rb-price').innerHTML
    }
  })
}

function getCollections () {
  const collectionContainers = document.querySelectorAll('.rb-box-builder .rb-section');
  return Array.from(collectionContainers).map(container => {
    return {
      id: container.id,
      el: container,
      title: container.querySelector('h2').innerText,
      products: getProducts(container)
    }
  })
}

function buildTagList (data) {
  var tags_to_display = [];
  var json = document.getElementById('tag-highlights');
  if (json) {
    try {
      json = JSON.parse(json.innerHTML);

      for (var tag of data.tags) {
        if (tag.indexOf('_') === -1) continue;

        var tag_id = tag.split(':')[0].replace('_', '').replace(/ /g, '').replace(/^\s+|\s+$/g, '');
        var tag_content = tag.split(':')[1];

        if (tag_content === 'No') continue;

        for (var compare_tag of json) {
          var compare_pieces = compare_tag.split(':');
          var compare_id = compare_pieces[0].replace(/ /g, '').replace(/^\s+|\s+$/g, '');
          var compare_background = compare_pieces[1];
          var compare_color = compare_pieces[2];

          if (compare_id == tag_id) {
            var tag_name = tag_id.charAt(0).toUpperCase() + tag_id.slice(1);
            var content = tag_id === 'region'
              ? tag_content.replace('-', ' ')
              : tag_content === 'Yes'
                ? tag_name
                : tag_content;
            tags_to_display.push(`
                <div class="product-info__tag" title="${tag_name}" style="background-color: ${compare_background};color: ${compare_color}">
                    ${tag_name}: ${content}
                </div>
            `);
          }
        }
      }

      if (tags_to_display.length) {
        return '<div class="margin-top-sm"><div class="product-info__tags flex gap-xxs"> ' + tags_to_display.join('') + ' </div></div>'
      }
      return '';
    } catch {
      return '';
    }
  } else {
    return '';
  }
}

class ReChargeProduct {
  constructor({ id, price }) {
    this.id = id;
    this.price = price;
    this.productsContainer = document.querySelector('recharge-products');
    this.quantity = 0;
    this.selected = false;
    this.product = null;

    const selectedProduct = this.productsContainer.selectedProducts.find(p => p.id === this.id);
    if (selectedProduct) {
      this.quantity = selectedProduct.quantity;
      this.selected = true;
    } else {
      this.quantity = 0;
      this.selected = false;
    }

    this.rechargeItem = document.querySelector('[data-rb-item-id="' + this.id + '"]');

    this.addOne = this.addOne.bind(this);
    this.removeAll = this.removeAll.bind(this);

    this.init();

    this.loadProduct = this.loadProduct.bind(this);
  }

  init () {
    this.productContainer = document.createElement('div');
    this.productContainer.classList.add('recharge-product', 'is-loading');
    this.productsContainer.appendChild(this.productContainer);
  }

  removeAll () {
    this.rechargeItem.querySelector('.rb-qty-wrapper .rb-input').value = 0;
    this.rechargeItem.querySelector('.rb-qty-wrapper .rb-input').dispatchEvent(new Event('change'));
    this.onQuantityUpdate();
  }

  loadProduct () {
    return fetch(`https://cheese-geek.myshopify.com/api/graphql`, {
      method: "post",
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": "2d99ad1220e780bbc49a802cba0fbd55"
      },
      body: `{
        product(id:"gid://shopify/Product/${this.id}") {
          title
          handle
          availableForSale
          description
          featuredImage {
            altText
            url(transform: { maxHeight: 400, maxWidth: 400 })
          }
          tags
          bundleDescription: metafield(namespace: "custom", key: "bundle_popup_description") {
            id,
            value
          }
          hardness: metafield(namespace: "cheese_rating", key: "hardness") {
            id,
            value
          }
          strength: metafield(namespace: "cheese_rating", key: "strength") {
            id,
            value
          }
          rating: metafield(namespace: "okendo", key: "ProductListingSnippet") {
            id,
            value
          }
          tip: metafield(namespace: "item_details", key: "top_tip") {
            id,
            value
          }
        }
      }`
    })
      .then(res => res.json())
      .then(this.renderProduct.bind(this));
  }

  renderProduct ({ data }) {
    this.product = data.product;
    this.productContainer.classList.remove('is-loading');

    if (this.selected) {
      this.productContainer.classList.add('selected');
    }

    if (!this.product.availableForSale) {
      this.productContainer.classList.add('sold-out');
    }

    this.productContainer.innerHTML = `
      <div class="recharge-product--label">
        On the board
      </div>
      <div class="recharge-product--image">
        <details is="recharge-popup">
          <summary>
            <img src="${this.product.featuredImage.url}" alt="${this.product.featuredImage.altText || this.product.title}" />
          </summary>

          <div class="recharge-bundle--popup recharge-product recharge-card">
            <button class="recharge-bundle--popup-close reset">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-81-337c9-9 25-9 34 0l47 47 47-47c9-9 24-9 34 0s9 25 0 34l-47 47 47 47c9 9 9 24 0 34s-25 9-34 0l-47-47-47 47c-10 9-25 9-34 0s-9-25 0-34l47-47-47-47c-9-10-9-25 0-34z"/></svg>
            </button>

            <div class="recharge-bundle--product-info">
                <div class="recharge-bundle--product-image">
                    <img src="${this.product.featuredImage.url}" alt="${this.product.featuredImage.altText || this.product.title}" />
                </div>
                
                <div class="recharge-bundle--product-content">
                  <div class="recharge-bundle--product-title">
                      ${this.product.title}
                  </div>
                  
                  ${this.product.rating ?
                    `<div data-oke-reviews-product-listing-rating>
                      ${this.product.rating.value}
                    </div>` : ''
                  }
                  
                  ${this.renderStats(this.product)}
                  ${buildTagList(this.product)}
                  
                  <div class="recharge-bundle--product-description">
                    ${this.product.bundleDescription ? convertSchemaToHtml(this.product.bundleDescription.value) : this.product.description}
                  </div>
                  
                  <div class="recharge-bundle--product-add">
                    <button class="btn btn-add btn--accent">Add to bundle</button>
                  </div>
                </div>
            </div>
          </div>
        </details>
      </div>
      <div class="recharge-product--info">
        <strong class="recharge-product--title">${this.product.title}</strong>
        <span class="recharge-product--price">${this.price}</span>
        <div class="recharge-product--add">
            <button class="btn btn-add btn--accent">Add</button>
        </div>
        <div class="recharge-product--quantity">
            <button class="btn btn--accent btn-minus"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 21"><g clip-path="url(#a)"><path fill="#fff" d="m18 10-1 2H3l-1-2 1-1h14l1 1Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M1 0h18v20H1z"/></clipPath></defs></svg></button>
            <span class="quantity">${this.quantity}</span>
            <button class="btn btn--accent btn-plus"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 21"><g clip-path="url(#a)"><path fill="#fff" d="m9 3 1-1 1 1v6h6l1 1-1 2h-6v5l-1 1-1-1v-5H3l-1-2 1-1h6V3Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M19 0H1v20h18z"/></clipPath></defs></svg></button>
        </div>
      </div>
    `;

    this.addListeners();
  }

  renderStats (stats) {
    let result = '';

    if (this.product.hardness) {
      var hardness = this.product.hardness.value;
      var hardnessRounded = Math.ceil(hardness);
      var half = false;

      if (hardness === hardnessRounded) {
        half = true
      }

      result += `
                <div class="flex items-center font-secondary margin-bottom-xxxs">
                    <span>Hardness:</span>
                    <div class="cheese-ratings flex gap-xxs">
                        ${[1,2,3,4,5].map(i => {
        return `<span style="width:12px;height:12px;" class="cheese-rating-circle
                                ${hardness < i
          ? half ? ' half-filled' : ''
          : ' filled'
        }
                          "></span>`
      }).join('')}
                    </div>
                </div>
      `;
    }

    if (this.product.strength) {
      var strength = this.product.strength.value;
      var strengthRounded = Math.ceil(strength);
      var half = false;

      if (strength === strengthRounded) {
        half = true
      }

      result += `
                <div class="flex items-center font-secondary margin-bottom-xxxs">
                    <span>Strength:</span>
                    <div class="cheese-ratings flex gap-xxs">
                        ${[1,2,3,4,5].map(i => {
        return `<span style="width:12px;height:12px;" class="cheese-rating-circle
                                        ${hardness < i
          ? half ? ' half-filled' : ''
          : ' filled'
        }
                                    "></span>`
      }).join('')}
                    </div>
                </div>
            `;
    }

    return result;
  }

  addListeners () {
    this.productContainer.querySelector('.btn-plus').addEventListener('click', this.addOne.bind(this));
    this.productContainer.querySelector('.btn-minus').addEventListener('click', this.minusOne.bind(this));
    this.productContainer.querySelectorAll('.btn-add')
      .forEach(el => {
        el.addEventListener('click', this.addOne.bind(this));
      })
  }

  onQuantityUpdate () {
    setTimeout(() => {
      this.quantity = this.rechargeItem.querySelector('.rb-input').value;
      this.productContainer.querySelector('.quantity').innerText = this.quantity;

      if (this.selected && this.quantity === "0") {
        this.selected = false;
        this.productContainer.classList.remove('selected');
      } else if (!this.selected && this.quantity !== "0") {
        this.selected = true;
        this.productContainer.classList.add('selected');
      }

      this.productsContainer.updateSelectedProducts({
        id: this.id,
        quantity: this.quantity,
        title: this.product.title,
        image: this.product.featuredImage.url
      });
    },0);
  }

  addOne () {
    this.rechargeItem.querySelector('.rb-btn-qty-plus').click();
    this.onQuantityUpdate();
  }

  minusOne () {
    this.rechargeItem.querySelector('.rb-btn-qty-minus').click();
    this.onQuantityUpdate();
  }

  updatePrice () {
    const price = this.productContainer.querySelector('.recharge-product--price');
    if (price)
      price.innerHTML = this.rechargeItem.querySelector('.rb-price').innerHTML
  }
}

class ReChargeProducts extends HTMLElement {
  constructor() {
    super();

    this.selectedProducts = [];

    this.cart = document.querySelector('recharge-cart');

    this.addProducts = this.addProducts.bind(this);
    this.setSelectedProducts = this.setSelectedProducts.bind(this);
  }

  init () {
    setTimeout(async () => {
      this.innerHTML = null;
      this.collections = getCollections();
      this.products = [];
      this.addons = [];

      this.addCollections();

      for (let collection of this.collections) {
        await this.addProducts(collection.products);
      }

      for (let addon of document.querySelectorAll('recharge-addon')) {
        this.addons.push(addon);
      }

      const urlParams = new URLSearchParams(window.location.search);

      //  ?with=4511035785258,1346899148842
      const withProductsStr = urlParams.get('with');
      const bundleProductsStr = urlParams.get('bundle');

      if (withProductsStr) {
        handleWithProducts(withProductsStr);
      } else if (bundleProductsStr) {
        document.getElementById('curate').click();
        document.querySelector('.recharge-option#' + bundleProductsStr).click();
      }
    }, 0)
  }

  setSelectedProducts (products, addons) {
    for (let product of this.selectedProducts) {
      const p = this.products.find(p => p.id === product.id);
      if (p) p.removeAll();
      const addon = this.addons.find(p => p.id === product.id)
      if (addon) addon.removeAll();
    }

    setTimeout(() => {
      for (let product of products) {
        const rechargeproduct = this.products.find(rcp => rcp.id === product);

        if (rechargeproduct) {
          rechargeproduct.addOne();
        }
      }

      if (addons && addons.length) {
        for (let addon of addons) {
          const rechargeaddon = this.addons.find(rcp => rcp.id === addon);

          if (rechargeaddon) {
            rechargeaddon.addOne();
          }
        }
      }
    }, 0)
  }

  updateSelectedProducts (product) {
    let selectedProduct = this.selectedProducts.find(p => p.id === product.id);

    if (selectedProduct) {
      selectedProduct.quantity = product.quantity;
    } else {
      selectedProduct = product;
      this.selectedProducts.push(selectedProduct);
    }

    this.selectedProducts = this.selectedProducts.filter(p => p.quantity != '0');
    this.cart.updateCart(this.selectedProducts);
    if (!product.addon) {
      this.updateQuantity();
    }
  }

  updateQuantity () {
    this.quantity = 0;
    for (let product of this.selectedProducts) {
      if (product.addon)
        continue;
      this.quantity = parseInt(this.quantity) + parseInt(product.quantity);
    }

    setTimeout(() => {
      document.querySelectorAll('.recharge-quantity').forEach(el => el.classList.remove('active'));

      const steps = Array.from(document.querySelectorAll('.recharge-bundle--block .recharge-bundle--progress-step')).map((el, key) => {
        return {
          quantity: el.dataset.quantity,
          index: key
        }
      });

      let currentStep = null;
      let nextStep = null;
      for (let step of steps) {
        if (this.quantity >= step.quantity) {
          currentStep = step;
        } else {
          nextStep = step;
          break;
        }
      }

      if (currentStep) {
        let className = 'one';
        switch (currentStep.index) {
          case 1:
            className = 'two';
            break;
          case 2:
            className = 'three';
            break;
          case 3:
            className = 'four';
        }
        document.querySelectorAll('.recharge-bundle--progress').forEach(el => el.classList.remove('one', 'two', 'three', 'four'));
        document.querySelectorAll('.recharge-bundle--progress').forEach(el => el.classList.add(className));
        document.querySelector(`.recharge-quantity[data-quantity="${currentStep.quantity}"]`)?.classList.add('active');

        const msgContainer = document.querySelector('.recharge-bundle--success-msg');
        const successMsg = document.querySelector(`.recharge-bundle--progress-step[data-quantity="${currentStep.quantity}"]`).dataset.success;
        if (successMsg) {
          if (nextStep) {
            msgContainer.innerHTML = successMsg.replace('{X}', nextStep.quantity - this.quantity);
          } else {
            msgContainer.innerHTML = successMsg;
          }
        } else {
          msgContainer.innerHTML = msgContainer.dataset.notReached.replace('{X}', nextStep.quantity - this.quantity);
        }
      } else {
        document.querySelectorAll('.recharge-bundle--progress').forEach(el => el.classList.remove('one', 'two', 'three', 'four'));
        const msgContainer = document.querySelector('.recharge-bundle--success-msg');
        msgContainer.innerHTML = msgContainer.dataset.notReached.replace('{X}', nextStep.quantity - this.quantity);
      }

      for (let product of this.products) {
        product.updatePrice();
      }
    },0)
  }

  addCollections () {
    this.sort = document.querySelector('.recharge-bundle--sort-options');

    this.sort.innerHTML = null;

    document.querySelector('details[is="recharge-sort"] summary').innerText = 'All';
    const allOption = document.createElement('div');
    allOption.classList.add('recharge-bundle--sort-option')
    allOption.dataset.value = 'all';
    allOption.innerText = "All";
    this.sort.appendChild(allOption);

    for (let collection of this.collections) {
      const sortOption = document.createElement('div');
      sortOption.classList.add('recharge-bundle--sort-option')
      sortOption.dataset.value = collection.id;
      sortOption.innerText = collection.title;
      this.sort.appendChild(sortOption);
    }
  }

  async addProducts (products) {
    const promises = [];

    for (let product of products) {
      let rechargeproduct = new ReChargeProduct(product);

      this.products.push(rechargeproduct);

      promises.push(rechargeproduct.loadProduct())
    }

    await Promise.all(promises);
  }
}

class ReChargeCart extends HTMLElement {
  constructor(props) {
    super(props);

    this.wrapper = this.querySelector('.product-wrapper');
    this.clearCart = document.querySelector('.recharge-bundle--cart-clear');

    this.renderEmptyCart();

    document.querySelector('.recharge-bundle--checkout')
      .addEventListener('click', this.onCheckout.bind(this));

    this.clearCart
      .addEventListener('click', function () {
        document.querySelector('recharge-products').setSelectedProducts([]);
      });
  }

  async onCheckout () {
    const addonProducts = document.querySelector('recharge-products').selectedProducts.filter(p => p.addon);
    const activeSellingPlan = document.querySelector('.recharge-bundle--frequency-option.active');
    const addonItems = [];

    for (let addonProduct of addonProducts) {
      const productEl = document.querySelector(`recharge-addon[data-id="${addonProduct.id}"]`);

      const data = {
        id: productEl.dataset.variantId,
        quantity: addonProduct.quantity
      }

      if (activeSellingPlan.dataset.name !== 'only-once') {
        data.selling_plan = productEl.getAttribute('data-' + activeSellingPlan.dataset.name);
      }

      addonItems.push(data);
    }

    if (addonItems.length) {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          items: addonItems
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(r => r.json())
        .then(console.log)
    }

    document.querySelector('.rb-btn').click();
  }

  renderEmptyCart () {
    this.clearCart.style.display = 'none';

    this.wrapper.innerHTML = `
      <div class="recharge-bundle--cart-empty">
        Add cheese to your board
      </div>
    `
  }

  updateCart (products) {
    this.wrapper.innerHTML = null;

    if (!products.length) {
      setTimeout(() => this.updatePrice(), 0);
      return this.renderEmptyCart();
    }

    this.clearCart.style.display = 'block';

    for (let product of products) {
      this.wrapper.innerHTML += `
        <div class="recharge-bundle--cart-item">
            <div class="recharge-bundle--cart-image">
                <img src="${product.image}" />
            </div>
            <div class="recharge-bundle--cart-title">
                ${product.title}
                ${product.quantity != '1' ? `<span class="recharge-bundle--cart-qty text-sm font-italic">(x${product.quantity})</span>`:''}
            </div>
            <div class="recharge-bundle--cart-remove">
                <button class="btn recharge-button" data-id="${product.id}">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 18"><g clip-path="url(#a)"><path fill="#7B6B58" d="M11 1h3l2 1-2 1H2L0 2l2-1h3l1-1h4l1 1ZM2 5h12v11l-2 2H4l-2-2V5Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M16 0H1v18h15z"/></clipPath></defs></svg>
                </button>
            </div>
        </div>
      `;

      this.updatePrice();
    }

    setTimeout(() => this.updatePrice(), 0);

    const productsContainer = document.querySelector('recharge-products');
    document.querySelectorAll('.recharge-bundle--cart-remove .btn')
      .forEach(el => {
        el.addEventListener('click', () => {
          const productEl = productsContainer.products.find(p => p.id === el.dataset.id);
          if (productEl) {
            productEl.removeAll();
          } else {
            document.querySelector('.recharge-addon-' + el.dataset.id).removeAll()
          }
        });
      });
  }

  updatePrice () {
    this.totalPrice = 0;

    const priceEl = document.querySelector('.status-bar-sign-up .thl-copy span[aria-label]');
    if (priceEl) {
      const fullPriceEl = priceEl.querySelector('.rb-full-price');
      if (fullPriceEl) {
        // has compare at price
        const comparePrice = priceEl.querySelector('.rb-full-price').innerHTML.replace('£', '') * 100;
        const fullPriceEl = priceEl.cloneNode(true);
        fullPriceEl.querySelector('.rb-full-price').outerHTML = null;
        const fullPrice = fullPriceEl.innerText.replace('£', '') * 100;

        let addons_compare = 0;
        let addons_price = 0;

        document.querySelectorAll('recharge-addon.selected')
          .forEach(el => {
            const prices = el.querySelector('.recharge-product--price--subscribe');
            const compareEl = prices.querySelector('s');
            const priceEl = prices.querySelector('span');
            let compare_at = 0;
            let price = priceEl.innerText.replace('£', '') * 100;

            if (compareEl) {
              compare_at = compareEl.innerText.replace('£', '') * 100;
            } else {
              compare_at = price;
            }

            addons_compare = addons_compare + compare_at;
            addons_price = addons_price + price;
          });

        const totalComparePrice = (comparePrice + addons_compare) / 100;
        const totalPrice = (fullPrice + addons_price) / 100;

        document.querySelector('.recharge-bundle--checkout span.price').innerHTML = `
          <s>£${totalComparePrice.toFixed(2)}</s>
          <span>£${totalPrice.toFixed(2)}</span>
        `;

        this.totalPrice = totalPrice;
      } else {
        const price = priceEl.innerHTML.replace('£', '') * 100;

        let addons_price = 0;
        document.querySelectorAll('recharge-addon.selected')
          .forEach(el => {
            const prices = el.querySelector('.recharge-product--price--onetime').innerText;
            let price = prices.replace('£', '') * 100;
            addons_price = addons_price + price;
          });

        const totalPrice = (price + addons_price) / 100;

        document.querySelector('.recharge-bundle--checkout span.price').innerHTML = `
          <span>£${totalPrice.toFixed(2)}</span>
        `;

        this.totalPrice = totalPrice;
      }
    } else {
      document.querySelector('.recharge-bundle--checkout span.price').innerHTML = ``;
    }

    if (this.totalPrice && this.totalPrice > Number(window.bundleMinPrice)) {
      document.querySelector('.recharge-bundle--min-msg').classList.remove('active');
      document.querySelector('.recharge-bundle--checkout').disabled = false;
    } else {
      document.querySelector('.recharge-bundle--min-msg').classList.add('active');
      document.querySelector('.recharge-bundle--checkout').disabled = true;
    }
  }
}

class ExtendedDetails extends HTMLDetailsElement {
  static observedAttributes = ['open'];

  constructor() {
    super();

    this.isOpen = false;

    this.handleClose = this.handleClose.bind(this);
    this.close = this.close.bind(this);
  }

  close () {
    this.removeAttribute('open');
    document.body.removeEventListener('click', this.handleClose);
    document.getElementsByTagName('body')[0].style.overflow = null;
  }

  handleClose (e) {
    const target = e.target.closest('details');

    if (target && target.id === this.id)
      return;

    this.close();
  }

  onAttributeChanged(name, oldValue, newValue) {
    if (newValue === '') {
      this.isOpen = true;

      document.getElementsByTagName('body')[0].style.overflow = 'hidden';

      document.body.addEventListener('click', this.handleClose);
    } else {
      this.isOpen = false;

      document.getElementsByTagName('body')[0].style.overflow = null;

      document.body.removeEventListener('click', this.handleClose);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.onAttributeChanged(name, oldValue, newValue);
  }
}

class ReChargeSort extends ExtendedDetails {
  constructor() {
    super();

    this.selectedOption = 'all';

    this.handleOptionClick = this.handleOptionClick.bind(this);

    document.body.addEventListener('click', this.handleOptionClick.bind(this));
  }

  handleOptionClick (e) {
    if (!e.target.closest('#' + this.id))
      return;

    if (e.target.closest('.recharge-bundle--sort-option')) {
      const target = e.target.closest('.recharge-bundle--sort-option');

      if (this.selectedOption !== target.dataset.value) {
        this.selectedOption = target.dataset.value;
        this.querySelector('summary').innerText = target.innerText;
        this.close();

        const productsContainer = document.querySelector('recharge-products');

        productsContainer.innerHTML = null;
        if (target.dataset.value === 'all') {
          for (let collection of productsContainer.collections) {
            productsContainer.addProducts(collection.products);
          }
        } else {
          const collection = productsContainer.collections.find(c => c.id === this.selectedOption);
          productsContainer.addProducts(collection.products);
        }
      }
    }
  }
}

class ReChargeFrequency extends HTMLElement {
  constructor(props) {
    super(props);

    this.addOptions = this.addOptions.bind(this);

    this.addEventListener('click', this.handleOptionClick.bind(this));
  }

  addOptions () {
    document.querySelectorAll('#selling-plan-list option')
      .forEach(option => {
        const optionEl = document.createElement('div');
        const optionName = option.innerText.toLowerCase().replace(/ /g, '-');
        optionEl.classList.add('recharge-bundle--frequency-option', 'btn', 'recharge-button');
        optionEl.innerText = option.innerText.replace('Delivery every', 'Every');
        optionEl.dataset.value = option.dataset.sellingPlanId;
        optionEl.dataset.name = optionName;

        if (option.selected) {
          optionEl.classList.add('active');
          const addonsContainer = document.querySelector('recharge-addons');
          addonsContainer.className = optionName;
        }

        this.appendChild(optionEl);
      });
  }

  handleOptionClick (e) {
    fixSellingPlanSelector();
    const option = e.target.closest('.recharge-bundle--frequency-option');

    if (!option) {
      return;
    }

    document.querySelectorAll('.recharge-bundle--frequency-option')
      .forEach(el => el.classList.remove('active'));

    const selector = document.getElementById('selling-plan-list');

    selector.value = selector.querySelector(`option[data-selling-plan-id="${option.dataset.value}"]`).value;
    selector.dispatchEvent(new Event('change'));
    option.classList.add('active');

    const productsContainer = document.querySelector('recharge-products');
    productsContainer.init();

    const addonsContainer = document.querySelector('recharge-addons');
    addonsContainer.className = option.dataset.name;

    document.querySelector('recharge-cart').updateCart(productsContainer.selectedProducts);
  }
}

class ReChargePopup extends ExtendedDetails {
  constructor() {
    super();

    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue === '') {
      document.body.addEventListener('click', this.handleBackgroundClick);
    } else {
      document.body.removeEventListener('click', this.handleBackgroundClick);
    }

    this.onAttributeChanged(name, oldValue, newValue);
  }

  handleBackgroundClick (e) {
    const popup = e.target.closest('.recharge-bundle--popup');
    const close = e.target.closest('.recharge-bundle--popup-close');

    if (popup && !close)
      return;

    this.close();
  }
}

class ReChargeOptions extends HTMLElement {
  constructor() {
    super();

    this.options = {};
    this.selectedOption = {};

    this.getOptions();
    this.setupEvents();
  }

  setupEvents () {
    this.querySelectorAll('.recharge-bundle--option .btn.recharge-button.recharge-option')
      .forEach(option => {
        option.addEventListener('click', this.selectOption.bind(this));
      });

    this.querySelectorAll('.recharge-bundle--option .btn.recharge-button.recharge-quantity')
      .forEach(option => {
        option.addEventListener('click', this.selectQtyOption.bind(this));
      });
  }

  getOptions () {
    this.querySelectorAll('.recharge-bundle--option .btn.recharge-button.recharge-option')
      .forEach(option => {
        const optionObj = {
          id: option.id,
          products: option.dataset.products.split(','),
        }

        if (option.dataset.addons) {
          optionObj.addons = option.dataset.addons.split(',');
          optionObj.addon_breaks = option.dataset.addonBreaks.split('/')
        }

        this.options[option.id] = optionObj;
      });
  }

  selectQtyOption (e) {
    if (!this.selectedOption.products) {
      document.querySelector('.recharge-option').click();
      return;
    }
    const productsContainer = document.querySelector('recharge-products');

    let products = [];

    for (let p of this.selectedOption.products) {
      if (products.length >= e.target.dataset.quantity) {
        break;
      }

      const rcp = productsContainer.products.find(rcp => rcp.id === p);
      if (rcp && rcp.product.availableForSale)
        products.push(p);
    }

    let addons = [];
    if (this.selectedOption.addons) {
      addons = [ ...this.selectedOption.addons ];
      const breakLength = this.selectedOption.addon_breaks[e.target.dataset.index];
      addons.length = breakLength;
    }
    productsContainer.setSelectedProducts(products, addons);

    if (e.scroll !== false) {
      window.scrollTo({
        top: document.querySelector('.recharge-bundle--products').getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
    }
  }

  selectOption (e) {
    if (e.target.classList.contains('active')) {
      document.querySelector('.recharge-bundle--cart-clear').click();
      this.querySelectorAll('.recharge-bundle--option .btn.recharge-button.recharge-option')
        .forEach(option => {
          option.classList.remove('active');
        });
      return;
    }

    this.querySelectorAll('.recharge-bundle--option .btn.recharge-button.recharge-option')
      .forEach(option => {
        option.classList.remove('active');
      });

    const option = this.options[e.target.id];
    this.selectedOption = option;
    const productsContainer = document.querySelector('recharge-products');

    e.target.classList.add('active');

    const selectedQtyOption = this.querySelector('.recharge-bundle--option .btn.recharge-button.recharge-quantity.active');
    if (selectedQtyOption) {
      this.selectQtyOption({
        target: selectedQtyOption
      });
      window.scrollTo({
        top: document.querySelector('.recharge-bundle--products').getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
    } else {
      const qtyOption = this.querySelector('.recharge-bundle--option .btn.recharge-button.recharge-quantity');
      this.selectQtyOption({
        target: qtyOption,
        scroll: false
      })
    }

    // document.querySelector('.recharge-bundle--products').style.display = null;
  }
}

class ReChargeCartSummary extends ExtendedDetails {
  constructor() {
    super();

    this.init();
  }

  init () {
    if (window.innerWidth > 1039) {
      this.setAttribute('open', true)
    }

    this.querySelector('.recharge-bundle--popup-close').addEventListener('click', () => {
      this.close()
    });
  }
}

class ReChargeAddon extends HTMLElement {
  constructor(props) {
    super(props);

    this.quantity = 0;
    this.selected = false;

    this.addListeners();

    this.removeAll = this.removeAll.bind(this);
  }

  addListeners () {
    this.querySelector('.btn-plus').addEventListener('click', this.addOne.bind(this));
    this.querySelector('.btn-minus').addEventListener('click', this.minusOne.bind(this));
    this.querySelectorAll('.btn-add')
      .forEach(el => {
        el.addEventListener('click', this.addOne.bind(this));
      })
  }

  addOne () {
    this.quantity = this.quantity + 1;
    this.onQuantityUpdate(this.quantity);
  }

  minusOne () {
    this.quantity = this.quantity - 1;
    this.onQuantityUpdate(this.quantity);
  }

  onQuantityUpdate () {
    setTimeout(() => {
      this.querySelector('.quantity').innerText = this.quantity;

      if (this.selected && this.quantity == "0") {
        this.selected = false;
        this.classList.remove('selected');
      } else if (!this.selected && this.quantity != "0") {
        this.selected = true;
        this.classList.add('selected');
      }

      document.querySelector('recharge-products').updateSelectedProducts({
        id: this.id,
        quantity: this.quantity,
        title: this.dataset.title,
        image: this.dataset.image,
        addon: true
      });
    },0);
  }

  removeAll () {
    this.quantity = 0;
    this.onQuantityUpdate();
  }
}

class ReChargeAddons extends HTMLElement {
  constructor() {
    super();

    this.addons = [];
  }

  init () {
    this.querySelectorAll('recharge-addon')
      .forEach(product => {
        this.addons.push(product)
      })
  }
}

class ReChargeSortAddons extends ExtendedDetails {
  constructor() {
    super();

    this.selectedOption = 'all';

    this.handleOptionClick = this.handleOptionClick.bind(this);

    document.body.addEventListener('click', this.handleOptionClick.bind(this));
  }

  handleOptionClick (e) {
    if (!e.target.closest('#' + this.id))
      return;

    if (e.target.closest('.recharge-bundle--sort-option')) {
      const target = e.target.closest('.recharge-bundle--sort-option');

      if (this.selectedOption !== target.dataset.value) {
        this.selectedOption = target.dataset.value;
        this.querySelector('summary').innerText = target.innerText;
        this.close();

        const addonsContainer = document.querySelector('recharge-addons');

        if (target.dataset.value === 'all') {
          document.querySelectorAll('recharge-addons .recharge-product')
            .forEach(el => el.style.display = null);
        } else {
          document.querySelectorAll('recharge-addons .recharge-product')
            .forEach(el => {
              if (el.dataset.collection !== target.dataset.value) {
                el.style.display = 'none'
              } else {
                el.style.display = null
              }
            });
        }
      }
    }
  }
}

document.querySelectorAll('.recharge-choose').forEach(function (el) {
  el.addEventListener('click', function (e) {
    document.querySelectorAll('.recharge-choose').forEach(function (el) {
      el.classList.remove('active');
    });

    if (e.target.id === 'curate') {
      document.querySelectorAll('.recharge-options').forEach(function (el) {
        el.style.display = 'block';
      });
      document.querySelector('.recharge-progress').style.display = 'none';
      e.target.classList.add('active');
    } else {
      document.querySelectorAll('.recharge-options').forEach(function (el) {
        el.style.display = 'none';
      });
      window.scrollTo({
        top: document.querySelector('.recharge-bundle--products').getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
      e.target.classList.add('active');
    }
  })
});

// if (rechargeChoose) rechargeChoose.addEventListener('click', function (e) {
//   const target = e.target.closest('.recharge-choose');
//
//   const active = target.classList.contains('active');
//
//   if (active) {
//     target.classList.remove('active');
//     document.querySelectorAll('.recharge-bundle--block').forEach(el => el.style.display = null);
//     document.querySelector('.recharge-progress').style.display = 'none';
//     // document.querySelector('.recharge-bundle--products').style.display = 'none';
//     document.querySelector('.recharge-option.active').classList.remove('active');
//     document.querySelector('.recharge-quantity.active').classList.remove('active');
//   } else {
//     target.classList.add('active');
//     document.querySelectorAll('.recharge-bundle--block').forEach(el => el.style.display = 'none');
//     document.querySelector('.recharge-progress').style.display = 'block';
//     // document.querySelector('.recharge-bundle--products').style.display = null;
//   }
// });

customElements.define('recharge-products', ReChargeProducts);
customElements.define('recharge-cart', ReChargeCart);
customElements.define('recharge-options', ReChargeOptions);
customElements.define('recharge-sort', ReChargeSort, { extends: 'details' });
customElements.define('recharge-frequency', ReChargeFrequency);
customElements.define('recharge-popup', ReChargePopup, { extends: 'details' });
customElements.define('recharge-cart-summary', ReChargeCartSummary, { extends: 'details' });
customElements.define('recharge-sort-addons', ReChargeSortAddons, { extends: 'details' });
customElements.define('recharge-addon', ReChargeAddon);
customElements.define('recharge-addons', ReChargeAddons);

function start () {
  document.querySelector('recharge-products').init();
  document.querySelector('recharge-frequency').addOptions();
  document.querySelector('.recharge-bundle--options.is-loading').classList.remove('is-loading');
  fixSellingPlanSelector();
}

function handleWithProducts (str) {
  const productsStr = str.split(',');
  document.querySelector('recharge-products').setSelectedProducts(productsStr);
}

function fixSellingPlanSelector () {
  // fix for frequency selector..
  document.getElementById('selling-plan-list')
    .querySelectorAll('option')
    .forEach(el => el.value = el.dataset.sellingPlanId);
}

function setupObserver () {
  const targetNode = document.getElementById('recharge-bundles');
  let targetProductNodes = targetNode.querySelector('[data-rb-item-id]');

  if (targetProductNodes) {
    start();
  } else {
    const observer = new MutationObserver((mutationList, observer) => {
      targetProductNodes = targetNode.querySelector('[data-rb-item-id]');
      if (targetProductNodes) {
        start();
        observer.disconnect();
      }
    });

    observer.observe(targetNode, { attributes: true, childList: true, subtree: true });
  }
}

setupObserver();

document.addEventListener('shopify:section:load', function () {
  setupObserver();
});





// rich text helper functions...

function convertSchemaToHtml(schema, options = {}) {
  let { scoped } = options
  let html = ''
  if (typeof schema === 'string' || schema instanceof String) {
    schema = JSON.parse(schema)
  }

  if (typeof options === 'string' || options instanceof String || options === true) {
    scoped = options
  }

  if (schema.type === 'root' && schema.children.length > 0) {
    if (scoped) {
      html += `
      <div class="${scoped === true ? `rte` : scoped}">
        ${convertSchemaToHtml(schema.children, options)}
      </div>
      `
    } else {
      html += convertSchemaToHtml(schema.children, options)
    }
  } else {
    for (const el of schema) {
      switch (el.type) {
        case 'paragraph':
          html += buildParagraph(el, options)
          break
        case 'heading':
          html += buildHeading(el, options)
          break
        case 'list':
          html += buildList(el, options)
          break
        case 'list-item':
          html += buildListItem(el, options)
          break
        case 'link':
          html += buildLink(el, options)
          break
        case 'text':
          html += buildText(el, options)
          break
        default:
          break
      }
    }
  }
  return html
}

function getClass(tag, classes) {
  if (classes && classes[tag]) {
    return classes[tag]
  } else {
    return null
  }
}

function outputAttributes(attributes) {
  if (!attributes && attributes?.class) return ''
  const ATTRIBUTE_SEPARATOR = ' '
  return Object.keys(attributes)
    .map(key => {
      if (attributes[key]) {
        return `${ATTRIBUTE_SEPARATOR}${key}="${attributes[key]}"`
      }
    })
    .join('')
}

function createElement(tag, classes, content, attributes = {}) {
  attributes = { ...attributes, class: getClass(tag, classes) }
  return `<${tag}${outputAttributes(attributes)}>${content}</${tag}>`
}

function buildParagraph(el, options) {
  const { classes } = options
  return createElement('p', classes, convertSchemaToHtml(el?.children, options))
}

function buildHeading(el, options) {
  const { classes } = options
  const tag = `h${el?.level}`
  return createElement(tag, classes, convertSchemaToHtml(el?.children, options))
}

function buildList(el, options) {
  const { classes } = options
  const tag = el?.listType === 'ordered' ? 'ol' : 'ul'
  return createElement(tag, classes, convertSchemaToHtml(el?.children, options))
}

function buildListItem(el, options) {
  const { classes } = options
  return createElement('li', classes, convertSchemaToHtml(el?.children, options))
}

function buildLink(el, options) {
  const { classes } = options
  const attributes = {
    href: el?.url,
    title: el?.title,
    target: el?.target,
  }
  return createElement('a', classes, convertSchemaToHtml(el?.children, options), attributes)
}

function buildText(el, options) {
  const { classes, newLineToBreak } = options
  if (el?.bold) {
    return createElement('strong', classes, el?.value)
  } else if (el?.italic) {
    return createElement('em', classes, el?.value)
  } else {
    return newLineToBreak ? el?.value?.replace(/\n/g, '<br>') : el?.value
  }
}